import type { PageSegmentLoadMetric } from '@atlassian/browser-metrics/page-segment-load';

import { createPageSegmentLoadMetric } from '../../createGatedPageSegmentLoadMetric.ts';
import { APP_NAVIGATION_SEGMENT_KEY } from '../../metric-keys/index.ts';

export const APP_NAVIGATION_METRIC: PageSegmentLoadMetric = createPageSegmentLoadMetric({
	key: APP_NAVIGATION_SEGMENT_KEY,
	ssr: window.__SSR_RENDERED__ ? { doneAsFmp: true } : undefined,
});
